// extracted by mini-css-extract-plugin
module.exports = {"container":"Section8_container__ZZREn","content":"Section8_content__Al_Kh","testimonial":"Section8_testimonial__3dyJK","source":"Section8_source__LT9Y4"};